<template>
  <div class="mask-content">
    <div
      class="coupon-item position-relative"
      v-for="(item,index) in shopCardList"
      :key="index"
      @click="reCoupon(item,index)"
    >
      <div class="position-relative d-flex flex-row van-row--align-center">
        <div class="flex-1 con">
          <div class="left">
            <span class="title">{{item.name}}</span>
            <span class="time">有效期至{{item.expiryDate}}</span>
          </div>
          <div class="right">
            <span class="price">{{item.balance}}</span>
            <!-- <span v-if="item.category == 1">满{{item.fullNumber}}可用</span>
            <span v-if="item.category == 0">无门槛使用</span>-->
          </div>
        </div>
        <div class="yticon icon-xuanzhong2 checkbox" :class="{checked: getChecked(item.id)}"></div>

        <!-- <div class="circle l"></div>
        <div class="circle r"></div>-->
      </div>

      <div class="con">
        <div class="left"></div>
        <div v-if="!item.valid" class="right getEd">不可用</div>
        <div v-if="item.valid" class="right get">可使用</div>
      </div>

      <div class="mask" v-if="!item.valid"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'my-coupon-own-list',
  props: {
    shopCardList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      checkIds: []
    }
  },
  mounted () {
  },
  methods: {
    getChecked (id) {
      return this.checkIds.indexOf(id) > -1
    },
    reCoupon (item, index) {
      if (this.checkIds.indexOf(item.id) > -1) {
        this.checkIds.splice(this.checkIds.indexOf(item.id), 1)
      } else {
        this.checkIds.push(item.id)
      }
      this.$emit('changeCardList', this.checkIds)
    }
  },
}
</script>
<style lang="scss" scoped>
/* 优惠券列表 */
.mask-content {
  width: 100%;
}
.coupon-item {
  display: flex;
  flex-direction: column;
  margin: 10px 12px;
  background: #fff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  border-radius: 10px;

  .con {
    display: flex;
    align-items: center;
    position: relative;
    padding: 5px 15px;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #f3f3f3;
      transform: scaleY(50%);
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    overflow: hidden;
  }

  .title {
    font-size: 16px;
    color: $font-color-dark;
    margin-bottom: 5px;
  }

  .time {
    font-size: 12px;
    color: $font-color-light;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 13px;
    color: $font-color-base;
  }
  .get {
    background-color: var(--theme-font-color);
    color: white;
    padding: 2px 10px;
    border-radius: 50px;
  }
  .getEd {
    background-color: grey;
    color: white;
    padding: 2px 10px;
    border-radius: 50px;
  }

  .price {
    font-size: 22px;
    color: $base-color;

    &:before {
      content: "￥";
      font-size: 17px;
    }
  }

  .tips {
    font-size: 12px;
    color: $font-color-light;
    line-height: 30px;
    padding-left: 30px;
  }

  .circle {
    position: absolute;
    left: -3px;
    bottom: -5px;
    z-index: 10;
    width: 10px;
    height: 10px;
    background: #f3f3f3;
    border-radius: 100px;

    &.r {
      left: auto;
      right: -3px;
    }
  }
}
.checkbox {
  font-size: 22px;
  line-height: 1;
  padding: 0px 15px 0 0;
  color: $font-color-disabled;
  background: #fff;
  border-radius: 50px;
}
.checked {
  color: var(--theme-font-color);
}
.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 9;
  background-color: rgba(255, 255, 255, 0.6);
}
</style>